module.exports = __webpack_public_path__ + "static/img/unlock-features.853dc0d2.svg";